import React, { useState, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, TextField, Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import { AuthContext } from '../../contexts/AuthContext';
import { translateError } from '../../utils/messages';

const SignInPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setIsAuthenticated, setUser } = useContext(AuthContext);
  const history = useHistory();

  const handleSignIn = async () => {
    try {
      const user = await Auth.signIn(email, password);
  
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        setUser(user);
        history.push('/signin/change-password');
      } else {
        // まずAuthContextの状態を更新
        setIsAuthenticated(true);
        setUser(user);
        
        // ステートの更新とヘッダー再レンダリングのために十分な遅延を設定
        setTimeout(() => {
          history.push('/');
        }, 100);
      }
    } catch (err) {
      console.error('Sign In Error:', err);
      setError(translateError(err.message));
    }
  };
  
  return (
    <div style={{ maxWidth: 400, margin: '0 auto', padding: 20 }}>
      <TextField
        id="email"
        name="email"
        label="メールアドレス"
        type="email"
        autoComplete="email"
        fullWidth
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        margin="normal"
      />
      <TextField
        id="password"
        name="password"
        label="パスワード"
        type="password"
        autoComplete="current-password"
        fullWidth
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        margin="normal"
      />
      {error && (
        <Typography color="error" variant="body2" style={{ marginTop: 10 }}>
          {error}
        </Typography>
      )}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleSignIn}
        style={{ marginTop: 20 }}
      >
        サインイン
      </Button>
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <Link
          to="/reset-password"
          style={{ textDecoration: 'none', marginRight: 10 }}
        >
          <Typography variant="body2" color="primary" style={{ fontSize: '15px' }}>
            パスワードを忘れた場合
          </Typography>
        </Link>
        <Link to="/register" style={{ textDecoration: 'none' }}>
          <Typography variant="body2" color="primary" style={{ fontSize: '15px' }}>
            新規登録
          </Typography>
        </Link>
      </div>
    </div>
  );
};

export default SignInPage;
